import React from 'react';
import { Button, intl, TextInput } from 'ehs-react';
import { Toggle } from 'ehs-react';
import { useViewStateStore } from '../../stores/viewState.store';
import { usePortletStore } from '../../App';

export function EnterEmail(): JSX.Element {
  const [
    email,
    emailConsent,
    institutionName,
    institutionLogo,
    nextState,
    previousState,
    setEmailConsent,
    setPatientPortalIdentifier,
    joinedOnlineAppointment
  ] = useViewStateStore(state => [
    state.viewStateData?.patientData.email,
    state.viewStateData?.patientData.emailConsentState,
    state.viewStateData?.selectedInstitution.name,
    state.viewStateData?.selectedInstitution.logo,
    state.nextState,
    state.previousState,
    state.setEmailConsent,
    state.setPatientPortalIdentifier,
    state.viewStateData?.joinedOnlineAppointment
  ]);
  const onNextClick = () => {
    setPatientPortalIdentifier();
    nextState();
  };
  const [disableAutoSendingNotes] = usePortletStore(state => [
    state.configuration.disableAutoSendingNotes
  ]);

  let emailConsentLabel;
  if (disableAutoSendingNotes) {
    emailConsentLabel = intl(
      'virtualvisitpatientportlet.patientform.email.consent.without.notes'
    );
  } else {
    emailConsentLabel = intl(
      'virtualvisitpatientportlet.patientform.email.consent'
    );
  }
  return (
    <>
      <div className="vvpp-content">
        <div className="vvpp-institution-header">
          {institutionLogo && (
            <img
              className="vvpp-header-institution-icon"
              src={`data:image/jpeg;base64,${institutionLogo}`}
              alt="Institution logo"
            />
          )}
          <h2 className="vvpp-institution-logo-header-text">
            {institutionName}
          </h2>
        </div>
        <h3>{intl('virtualvisitpatientportlet.email.header')}</h3>
        <TextInput
          type="text"
          label={intl('email')}
          value={email}
          disabled={true}
        />
        <Toggle
          label={emailConsentLabel}
          onChange={setEmailConsent}
          value={emailConsent}
        />
      </div>
      <div className="vvpp-multi-buttons vvpp-buttons-bottom">
        {!joinedOnlineAppointment && (
          <Button
            id="vvpp-email-back-button"
            variant="gray"
            disabled={false}
            onClick={previousState}
            text={intl('view.button.back')}
          />
        )}
        <Button
          id="vvpp-email-next-button"
          variant="primary"
          disabled={false}
          onClick={onNextClick}
          text={intl('view.button.next')}
        />
      </div>
    </>
  );
}
